import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstrumentsService } from '@app/modules/instruments-modules/instruments.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule
  ],
  providers: [
    InstrumentsService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class InstrumentsModule {}
